export const MISSION_CODES = {
  CODE: "CODE",
};

export const AUDIT_STATUSES = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  ARCHIVED: "ARCHIVED",
  CANCELED: "CANCELED",
  ACTION_NEEDED: "ACTION_NEEDED",
  COMPLETED: "COMPLETED",
};

export const ADMIN_MODIFICATIONS_AUDIT_STATUSES = [
  AUDIT_STATUSES.ACTION_NEEDED,
  AUDIT_STATUSES.COMPLETED,
];

export const QUESTION_STATUSES = {
  INSUFFICIENT: "INSUFFICIENT",
  TO_IMPROVE: "TO_IMPROVE",
  COMPLIANT: "COMPLIANT",
  STRENGTH: "STRENGTH",
};

export const COMPLETE_QUESTION_STATUSES = {
  ...QUESTION_STATUSES,
  NOT_CONCERNED: "NOT_CONCERNED",
  NOT_EVALUATED: "NOT_EVALUATED",
};

export const CHOICE_ORDER_MAPPING = {
  1: QUESTION_STATUSES.STRENGTH,
  2: QUESTION_STATUSES.COMPLIANT,
  3: QUESTION_STATUSES.TO_IMPROVE,
  4: QUESTION_STATUSES.INSUFFICIENT,
  5: COMPLETE_QUESTION_STATUSES.NOT_CONCERNED,
  6: COMPLETE_QUESTION_STATUSES.NOT_EVALUATED,
};

export const AUDIT_TYPES = {
  ACTIVITY_MONITORING: "ACTIVITY_MONITORING",
  ISO17029_COMPLIANCE_AUDIT: "ISO17029_COMPLIANCE_AUDIT",
  INTERNAL_AUDIT_REPORT: "INTERNAL_AUDIT_REPORT",
  SCORED_AUDIT_REPORT: "SCORED_AUDIT_REPORT",
  TECHNICAL_AUDIT_SUMMARY: "TECHNICAL_AUDIT_SUMMARY",
};

export const TASK_RESULT_STATUSES = {
  PENDING: "PENDING",
  PROGRESS: "PROGRESS",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};

export const TASK_RESULT_TYPES = {
  REPORT_GENERATION: "REPORT_GENERATION",
  OTHER: "OTHER",
};
